export interface ProductImageItem {
  file: File;
  preview: string;
  isPrimary: boolean;
}

export interface LookupItem {
  id: number;
  titleEn: string;
  titleAr: string;
}

export const BACKEND_ERROR_FIELD_MAP: Record<string, string> = {
  'PRODUCT-0003': 'englishName',
  'PRODUCT-0004': 'arabicName',
  'PRODUCT-0002': 'barcode',
};
